"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableExports = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function useTableExports() {
    const exportDialogRef = react_1.useRef(null);
    const openExportDialog = event_callback_hook_1.useEventCallback(() => { var _a; return (_a = exportDialogRef.current) === null || _a === void 0 ? void 0 : _a.open(); });
    const closeExportDialog = event_callback_hook_1.useEventCallback(() => { var _a; return (_a = exportDialogRef.current) === null || _a === void 0 ? void 0 : _a.close(); });
    return {
        exportDialogRef,
        openExportDialog,
        closeExportDialog,
    };
}
exports.useTableExports = useTableExports;
//# sourceMappingURL=table-export-hook.js.map